import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest } from "../../api/ApiClient";
import UsersDTO from "../../model/dto/UsersDTO";
import GenericUtils from "../../utils/GenericUtils";

const route = "/docente/v1/usuarios";

async function getUser(userCode: string, instance: IPublicClientApplication) {
    return axiosGetRequest(
        `${route}/${userCode}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

async function getUserWithMatriculaAdp(
    matriculaAdp: string,
    instance: IPublicClientApplication
) {
    const query = `query=docente(matriculaAdp = "${matriculaAdp}")`;
    return axiosGetRequest(
        `${route}?${query}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

async function getUsers(
    usersDTO: UsersDTO,
    queryParam: string,
    instance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}?orderBy=nome&sortOrder=ASCENDING&maxResults=${
            usersDTO._limit
        }&page=${Number(usersDTO._offset)}${queryParam}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

async function getProfiles(instance: IPublicClientApplication) {
    return axiosGetRequest(
        `${route}/perfis`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default { getUser, getUsers, getProfiles, getUserWithMatriculaAdp };
